// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import AutoSelectRadioController from './auto_select_radio_controller';
import BootstrapToggleController from './bootstrap_toggle_controller';
import ClipboardController from './clipboard_controller';
import CocoonController from './cocoon_controller';
import DisableController from './disable_controller';
import EmailInputController from './email_input_controller';
import EnableSubmitController from './enable_submit_controller';
import FileDropZoneController from './file_drop_zone_controller';
import ImageZoomController from './image_zoom_controller';
import ObfuscationController from './obfuscation_controller';
import PasswordVisibilityController from './password_visibility_controller';
import AdminEditablePolicyFilterController from './admin/editable/policy_filter_controller';
import ReloadPageWithParamsController from './reload_page_with_params_controller';
import ReorderController from './reorder_controller';
import SaRPAScriptsExecutionController from './sa/rpa_scripts/execution_controller';
import TomSelectController from './tom_select_controller';
import SelectAllController from './select_all_controller';
import StateController from './state/state_controller';
import TurboPollingController from './turbo/polling_controller';
import TurboSyncController from './turbo/sync_controller';
import TurboOnBlurController from './turbo/on_blur_controller';
import UrlOpenModalController from './url_open_modal_controller';
import AutoscrollOnUpdateController from './autoscroll_on_update_controller';
import ScrollDownButtonController from './scroll_down_button_controller';
import ToggleElementsController from './toggle_elements_controller';
import ElapsedTimerController from './elapsed_timer_controller';
import MarkdownController from './markdown_controller';
import AiRpaRenewalRetrievalsEventsFormController from './ai/rpa/renewal_retrievals/events/form_controller';
import EdiElementController from './edi_element_controller';
import ValueChangeWarningController from './value_change_warning_controller';
import FormAutoSubmitController from './form_auto_submit_controller';
import TrixEnhancedController from './trix_enhanced_controller';
import SelectTextCaptureController from './select_text_capture_controller';
import CascadingSelectController from './cascading_select_controller';

application.register('auto-select-radio', AutoSelectRadioController);
application.register('bootstrap-toggle', BootstrapToggleController);
application.register('clipboard', ClipboardController);
application.register('cocoon', CocoonController);
application.register('disable', DisableController);
application.register('email-input', EmailInputController);
application.register('enable-submit', EnableSubmitController);
application.register('file-drop-zone', FileDropZoneController);
application.register('image-zoom', ImageZoomController);
application.register('obfuscation', ObfuscationController);
application.register('password-visibility', PasswordVisibilityController);
application.register('admin-editable-policy-filter', AdminEditablePolicyFilterController);
application.register('reload-page-with-params', ReloadPageWithParamsController);
application.register('reorder', ReorderController);
application.register('sa-rpa-scripts-execution', SaRPAScriptsExecutionController);
application.register('tom-select', TomSelectController);
application.register('select-all', SelectAllController);
application.register('state', StateController);
application.register('turbo-polling', TurboPollingController);
application.register('turbo-sync', TurboSyncController);
application.register('turbo-on-blur', TurboOnBlurController);
application.register('url-open-modal', UrlOpenModalController);
application.register('autoscroll-on-update', AutoscrollOnUpdateController);
application.register('scroll-down-button', ScrollDownButtonController);
application.register('toggle-elements', ToggleElementsController);
application.register('elapsed-timer', ElapsedTimerController);
application.register('markdown', MarkdownController);
application.register('ai-rpa-renewal-retrievals-events-form', AiRpaRenewalRetrievalsEventsFormController);
application.register('edi-element', EdiElementController);
application.register('value-change-warning', ValueChangeWarningController);
application.register('form-auto-submit', FormAutoSubmitController);
application.register('trix-enhanced', TrixEnhancedController);
application.register('select-text-capture', SelectTextCaptureController);
application.register('cascading-select', CascadingSelectController);
